export default __webpack_public_path__ + "static/media/image-coming-soon.85d8d1ed.jpg";